var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',[_c('i-col',{staticClass:"m-b-5",attrs:{"span":"24"}},[_c('a',{staticStyle:{"float":"right","line-height":"30px"},on:{"click":_vm.showProductPublicityModal}},[_vm._v("+新增项目公示")])])],1),_c('Table',{attrs:{"size":"small","columns":_vm.columnSpacedata,"data":_vm.tableData,"stripe":""}}),_c('publicityModal',{ref:"productPublic"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }